import {useState, Dispatch, SetStateAction} from 'react'
import {useParams, useLocation} from 'react-router-dom'
import {Space} from 'antd'

import styles from './ProjectDrawdowns.module.scss'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {User} from 'modules/users'
import {
  Loader,
  Block,
  Text,
  Button,
  Modal,
  MagicWandIcon,
} from 'common/components'
import {useOpen} from 'common/hooks'
import {
  ProjectDrawdownsStats,
  ProjectDrawdownsList,
  ProjectDrawdown,
  DrawdownForm,
  useGetDrawdowns,
  useGetProject,
  DrawdownItem,
} from '..'

interface ContentProps {
  project: any
  drawdowns: DrawdownItem[]
}

interface HelpBorrowerProps {
  borrower: User
  setDrawdownUuid: Dispatch<SetStateAction<string>>
}

/**
 * Projects - Drawdowns页面
 * @returns 
 */
export default function ProjectDrawdowns() {
  const params = useParams()
  const {data: project} = useGetProject(params.uuid)
  const {data: drawdowns} = useGetDrawdowns(params.uuid)

  if (!drawdowns) return <Loader />

  return <Content project={project} drawdowns={drawdowns} />
}

const Content = ({project, drawdowns}: ContentProps) => {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const {hash} = useLocation()
  const [drawdownUuid, setDrawdownUuid] = useState(
    (hash &&
      drawdowns.find((drawdown) => drawdown.uuid === hash.slice(1))?.uuid) ||
      drawdowns[0]?.uuid
  )

  return (
    <div className={styles.root}>
      <div>
        <ProjectDrawdownsStats />
        {drawdownUuid && (
          <ProjectDrawdownsList
            drawdownUuid={drawdownUuid}
            setDrawdownUuid={setDrawdownUuid}
          />
        )}
      </div>
      <div className={styles.details}>
        { !!permissions?.includes('drawdown request') && (
          <HelpBorrower
            borrower={project.borrower}
            setDrawdownUuid={setDrawdownUuid}
          />
        )}
        <ProjectDrawdown key={drawdownUuid} drawdownUuid={drawdownUuid} />
      </div>
    </div>
  )
}

const HelpBorrower = ({borrower, setDrawdownUuid}: HelpBorrowerProps) => {
  const [isOpen, handleOpen, handleClose] = useOpen()

  return (
    <>
      <Block type="grey" className={styles.block}>
        <Space size={6}>
          <MagicWandIcon />
          <Text as="h4" weight="demiBold">
            Help borrower
          </Text>
        </Space>
        <Text color="grey" mt={4} mb={8}>
          You can help {borrower && borrower.firstName} to create drawdown on their behalf.
        </Text>
        <Button variant="secondary" onClick={handleOpen}>
          create drawdown
        </Button>
      </Block>
      <Modal
        width={848}
        title="Drawdown request"
        open={isOpen}
        onCancel={handleClose}
      >
        <DrawdownForm setDrawdownUuid={setDrawdownUuid} onClose={handleClose} />
      </Modal>
    </>
  )
}
